import {
    ButtonProps,
    Dialog,
    DialogActions,
    DialogContent,
    DialogProps,
    DialogTitle,
    Stack,
    Tooltip,
    Typography,
} from '@mui/material';

import Button from 'domains/core/components/Button';

export type Props = {
    'data-testid'?: string;
    icon: React.ReactNode;
    title: string;
    body: React.ReactNode;
    buttonOneText: string;
    buttonTwoText: string;
    isOpen: boolean;
    buttonOneOnClick: () => void;
    buttonTwoOnClick: () => void;
    onClose: () => void;
    actionIcon?: JSX.Element;
    actionIconTooltip?: string;
    buttonOneProps?: ButtonProps;
    buttonTwoProps?: ButtonProps;
    dialogProps?: DialogProps;
};

const DialogStandard = ({
    'data-testid': dataTestId,
    icon,
    title,
    body,
    buttonOneText,
    buttonTwoText,
    isOpen,
    buttonOneOnClick,
    buttonTwoOnClick,
    onClose,
    actionIcon,
    actionIconTooltip,
    buttonOneProps,
    buttonTwoProps,
    ...dialogProps
}: Props) => (
    <Dialog
        maxWidth="sm"
        fullWidth
        open={isOpen}
        onClose={onClose}
        aria-labelledby="curation-success-modal"
        data-testid={dataTestId}
        {...dialogProps}
    >
        <DialogTitle>
            <Stack direction="row" alignItems="flex-end" spacing={2}>
                {icon}
                <Typography variant="h6">{title}</Typography>
            </Stack>
        </DialogTitle>
        <DialogContent>{body}</DialogContent>
        <DialogActions>
            <Stack direction="row" justifyContent="space-between" alignItems="flex-end" width="100%">
                {actionIcon && actionIconTooltip && <Tooltip title={actionIconTooltip}>{actionIcon}</Tooltip>}
                <Stack direction="row" columnGap={2}>
                    <Button
                        variant="text"
                        onClick={() => buttonOneOnClick()}
                        data-testid="dialog-button-one"
                        {...buttonOneProps}
                    >
                        {buttonOneText}
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => buttonTwoOnClick()}
                        data-testid="dialog-button-two"
                        {...buttonTwoProps}
                    >
                        {buttonTwoText}
                    </Button>
                </Stack>
            </Stack>
        </DialogActions>
    </Dialog>
);

export default DialogStandard;
